<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em;">To my Mother and Father, for never taking the boldness out of me and for always lending me money.</p><br/>
<p style="text-indent:00em;">To my Uncle, for sponsoring a millennial.</p><br/>
<p style="text-indent:00em;">To Paul Mauch, for your saintly patience.</p><br/>
<p style="text-indent:00em;">To Tatiana Ajder, for your companionship, kindness and intuition. You are a true delight.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5cd07240